import { Component } from '@angular/core';
import { DialogService } from './services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/languageService/language-service.service';
import { StateConfigrationService } from './services/common/state-configration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Senem_Admin';
  constructor(
    private dialogService: DialogService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private stateConfigService: StateConfigrationService
  ) {
    translateService.addLangs(['eng', 'spa']);
    translateService.setDefaultLang('eng');
  }
  ngOnInit() {
    this.languageService.language$.subscribe(language => {
      this.translateService.use(language);
    });

    // Call API on refresh
    this.stateConfigService.fetchStateConfiguration();
  }
}
